export const ACQUISITION_FORM_LINKS = {
  CUSTOMER_TYPE: "/",
  CONTRACT_TYPE: (customerType: string) => `/${customerType}/contract-type`,
  CONTACT: (customerType: string, product: string) => `/${customerType}/${product}/contact`,
  CONSUMPTION_POINT: (customerType: string, product: string) => `/${customerType}/${product}/consumption-point`,
  PRODUCTION_POINT: (customerType: string, product: string) => `/${customerType}/${product}/production-point`,
  PAYMENT: (customerType: string, product: string) => `/${customerType}/${product}/payment`,
  SUMMARY: (customerType: string, product: string) => `/${customerType}/${product}/summary`,
}
